module.exports = __webpack_public_path__ + "img/logo@3x.493dda96.png";